export default __webpack_public_path__ + "static/media/room-propolis-3.f6087682.webp";